import { Component, OnInit } from '@angular/core';
import {UserService} from '../../../../../services/users-service/user-service';
import {ActivatedRoute, Router} from '@angular/router';
import {AnonymousService} from '../../../../../services/anonymous-service';
import {SharedService} from '../../../../../services/shared-service/shared.service';

@Component({
  selector: 'app-user-agents',
  templateUrl: './user-agents.component.html',
  styleUrls: ['./user-agents.component.scss']
})
export class UserAgentsComponent implements OnInit {
  public userId: number;
  public userAgents: any;

  constructor(public _sharedService: SharedService, public router: Router, public anonymousService: AnonymousService,
              public agentService: UserService, public activatedRoute: ActivatedRoute) {
    this.activatedRoute.parent.params.subscribe(params => {
      this.userId = +params['id'];
    })
    this._sharedService.selectedMenu('three');
    this.getUserAgents();
  }

  ngOnInit() {
  }

  // get all agents info
  getUserAgents() {
    this.agentService.getUserAgents(this.userId).subscribe(
      data => {
        // console.log(data);
        this.userAgents = data;
      },
      err => {
        // console.log(err);
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/User management/user-page/user-agents/user-agents.component.ts